export const markups = [
  { title: "Печать плашкой", percent: 10 },
  { title: "Сложное совмещение", percent: 10 },
  { title: "Pantone C", percent: 5 },
  { title: "Печать золото или серебро", percent: 7 },
  { title: "Растр", percent: 10 },
  { title: "24 часа", percent: 100 },
];
